module.exports = __webpack_public_path__ + "img/Strip-Front-B2-Ca-Jd.252d21f9.png";